<template>
  <el-dialog
    class="comp-container"
    :visible.sync="visible"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="title">修改课中昵称</div>
    <div class="tips">请输入修改后的昵称（仅在本课程中生效）</div>
    <div class="input">
      <el-input
        v-model="nickname"
        placeholder="请输入用户昵称(0/15)"
        :maxlength="15"
        @change="(val) => (nickname = val.trim())"
      ></el-input>
    </div>
    <div class="footer">
      <el-button @click="handleCancel"> 取消 </el-button>
      <el-button type="primary" @click="handleConfirm" v-preventReClick>
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { updateNickname } from "@saas/server-api/src/live-sdk";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  name: "ChangeNicknameDialog",
  data() {
    return {
      visible: false,
      nickname: "",
    };
  },
  computed: {
    ...mapState("live", [
      // "allMemberStatus",
      "roomInfo",
      "showChangeNickname",
      "imService",
      "userStatus",
    ]),
  },
  methods: {
    ...mapMutations("live", [
      "setShowChangeNickname",
      // "setAllMemberStatus",
      "setAllMemberStatusMap",
      "setUserStatus",
    ]),
    handleCancel() {
      this.visible = false;
      this.setShowChangeNickname({
        visible: false,
        info: {},
      });
    },
    handleConfirm() {
      if (
        !this.nickname ||
        !String(this.nickname).trim().length ||
        this.nickname === this.showChangeNickname.info.nickname
      ) {
        this.handleCancel();
        return;
      }
      const params = {
        user_id: this.showChangeNickname.info.userId,
        nickname: this.nickname,
        room_id: this.roomInfo.id,
      };
      updateNickname(params)
        .then((res) => {
          if (res.code === 1) {
            const data = {
              userId: params.user_id,
              nickname: params.nickname,
              serverTime: res.serverTime,
            };
            this.imService.sendMGLiveRoomCustomMsg({
              cmdId: 2,
              data: {
                type: "updateNickname",
                data,
              },
            });
            EventBus.$emit("updateNickname", data);
            // 发送响应
            if (window.ipcRenderer) {
              window.ipcRenderer.send("update-nickname", data);
            }
            // let allMemberStatus = this.allMemberStatus;
            // const tempIndex = allMemberStatus.findIndex(
            //   (item) => item.user_id === params.user_id
            // );
            // console.log("tempIndex", tempIndex, allMemberStatus);

            // if (tempIndex >= 0) {
            // allMemberStatus[tempIndex] = Object.assign(
            //   allMemberStatus[tempIndex],
            //   {
            //     nickname: params.nickname,
            //     name: params.nickname,
            //     serverTime: res.serverTime,
            //   }
            // );
            // if (params.user_id === this.userStatus?.user_id) {
            //   this.setUserStatus({
            //     nickname: params.nickname,
            //     serverTime: res.serverTime,
            //   });
            // }
            // console.log("___allMemberStatus", allMemberStatus);

            // this.setAllMemberStatus(allMemberStatus);
            // this.setAllMemberStatusMap({
            //   user_id: params.user_id,
            //   name: params.nickname,
            //   nickname: params.nickname,
            // });
            // this.handleCancel();
            // }
            this.$darkMessage.success("昵称修改成功");
            this.visible = false;
            this.handleCancel();
          } else {
            this.$darkMessage.error(res.message);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    open() {
      this.visible = true;
      this.nickname = this.showChangeNickname?.info?.nickname || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #f7f8fa;

      text-align: center;
      .title {
        width: 100%;
        font-weight: 600;
        font-size: 18px;
        color: #ecedee;
        line-height: 28px;
        text-align: left;
      }
      .tips {
        max-width: 300px;
        height: 48px;
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .input {
        .el-input {
        }
        .el-input__inner {
          background: #27272a;
          box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
          border-radius: 12px 12px 12px 12px;
          color: #fff;
          border: none;
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
